module.exports = __webpack_public_path__ + "zip/General3x3.zip";